import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- entities
import Menu from 'PMT/entities/menu/Menu';

// -- views

class MenuItem extends Component {

  static propTypes = {
    menu: PropTypes.instanceOf(Menu).isRequired,

    isSelected: PropTypes.bool.isRequired,

    onSelect: PropTypes.func,

    onDeselect: PropTypes.func
  };

  defaultProps = {
    onSelect: () => {},
    onDeselect: () => {}
  };

  shouldComponentUpdate(nextProps) {
    return nextProps.isSelected !== this.props.isSelected
      && nextProps.menu.id !== this.props.menu.id;
  }

  onSelect = () => {
    this.props.onSelect(this.menu);
  };

  onDeselect = () => {
    this.props.onDeselect(this.menu);
  };

  onClick = () => {
    if (this.isSelected) {
      this.onDeselect();
    } else {
      this.onSelect();
    }
  };

  get menu(): Menu {
    return this.props.menu;
  }

  get isSelected(): boolean {
    return this.props.isSelected;
  }

  render() {
    return (
      <div
        className="menu_item pointer"
        onClick={this.onClick}
      >
        {this.menu.name}
      </div>
    );
  }

}

export default MenuItem;
